module.exports = __webpack_public_path__ + "img/bj43.1b3f3388.png";